import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { MapPin, Check, ChevronDown } from "lucide-react";

export default function CitySwitcher() {
  const { user, refresh } = useAuth();
  const [open, setOpen] = useState(false);
  const [cities, setCities] = useState([]);
  const [switching, setSwitching] = useState(false);

  useEffect(() => {
    api.get("/cities").then(({ data }) => setCities(data.cities || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (!open) return;
    const onClick = (e) => {
      if (!e.target.closest("[data-cs-city-switcher]")) setOpen(false);
    };
    window.addEventListener("click", onClick);
    return () => window.removeEventListener("click", onClick);
  }, [open]);

  const switchTo = async (city) => {
    if (city === user?.city) {
      setOpen(false);
      return;
    }
    setSwitching(true);
    try {
      await api.post("/users/me/city", { city });
      await refresh();
      setOpen(false);
    } finally {
      setSwitching(false);
    }
  };

  return (
    <div className="relative" data-cs-city-switcher>
      <button
        onClick={() => setOpen((o) => !o)}
        className="brut-chip bg-[var(--cs-yellow)] hover:translate-x-[-1px] hover:translate-y-[-1px] transition-transform"
        data-testid="city-switcher-btn"
        title="Change city"
      >
        <MapPin size={12} />
        <span className="max-w-[110px] truncate">{(user?.city || "Knoxville, TN").split(",")[0]}</span>
        <ChevronDown size={12} />
      </button>
      {open && (
        <div
          className="absolute right-0 top-full mt-2 w-56 brut-card bg-white z-50 overflow-hidden"
          data-testid="city-switcher-dropdown"
        >
          {cities.map((c) => (
            <button
              key={c}
              onClick={() => switchTo(c)}
              disabled={switching}
              data-testid={`city-option-${c.split(",")[0].toLowerCase()}`}
              className={`w-full text-left px-4 py-3 text-sm font-bold hover:bg-[var(--cs-money)] flex items-center justify-between transition-colors ${
                c === user?.city ? "bg-[var(--cs-money)]" : ""
              }`}
              style={{ borderBottom: "2px solid var(--cs-ink)" }}
            >
              <span>{c}</span>
              {c === user?.city && <Check size={14} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
